"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getXCAmpleToken = exports.getXCAmpleController = exports.getAMPLToken = exports.getAmpleforthPolicy = exports.getAmpleforthCPIOracles = exports.getAmpleforthCPIOracle = exports.getAmpleforthMarketOracle = exports.getTokenApproval = exports.getTokenBalances = exports.getTokenBalance = exports.getXCRebases = exports.getXCToken = exports.getXCController = exports.getRebases = exports.getToken = exports.getPolicy = exports.getOracleProviderReports = exports.getOracle = exports.entities = exports.queries = exports.deployments = exports.abis = void 0;
const abis = __importStar(require("./abis"));
exports.abis = abis;
const deployments = __importStar(require("./deployments"));
exports.deployments = deployments;
const queries = __importStar(require("./queries"));
exports.queries = queries;
const entities = __importStar(require("./entities"));
exports.entities = entities;
const entities_1 = require("./entities");
const queries_1 = require("./queries");
const DEFAULT_CHAIN_ID = 1;
const DEFAULT_CLIENT = queries.initializeClient(queries.graphHostedURL(DEFAULT_CHAIN_ID));
// Query methods
function getOracle(address, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const dt = yield client
            .query(queries_1.GET_ORACLE_DATA, { id: address.toLowerCase() })
            .toPromise();
        return new entities_1.Oracle(dt.data.medianOracles[0]);
    });
}
exports.getOracle = getOracle;
function getPolicy(address, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const dt = yield client
            .query(queries_1.GET_POLICY_DATA, { id: address.toLowerCase() })
            .toPromise();
        return new entities_1.Policy(dt.data.policies[0]);
    });
}
exports.getPolicy = getPolicy;
function getToken(address, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const dt = yield client
            .query(queries_1.GET_TOKEN_DATA, { id: address.toLowerCase() })
            .toPromise();
        return new entities_1.Token(dt.data.tokens[0]);
    });
}
exports.getToken = getToken;
function getXCController(address, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const dt = yield client
            .query(queries_1.GET_XC_CONTROLLER_DATA, { id: address.toLowerCase() })
            .toPromise();
        return new entities_1.XCController(dt.data.xccontrollers[0]);
    });
}
exports.getXCController = getXCController;
function getXCToken(address, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const dt = yield client
            .query(queries_1.GET_XC_TOKEN_DATA, { id: address.toLowerCase() })
            .toPromise();
        return new entities_1.XCToken(dt.data.xctokens[0]);
    });
}
exports.getXCToken = getXCToken;
// NOTE: issue exists while pagination in the graph such that
// skip can't be more than 5000.
// TODO: Alternatively Query using timestamp ranges
function getOracleProviderReports(oracleAddress, providerAddress, client) {
    return __awaiter(this, void 0, void 0, function* () {
        let skip = 0;
        const reports = [];
        while (true) {
            try {
                const dt = yield client
                    .query(queries_1.GET_PROVIDER_REPORTS, {
                    providerID: oracleAddress
                        .toLowerCase()
                        .concat('|')
                        .concat(providerAddress.toLowerCase()),
                    first: queries_1.MAX_PER_PAGE,
                    skip,
                })
                    .toPromise();
                if (!dt.data || dt.data.oracleReports.length == 0) {
                    break;
                }
                for (const r of dt.data.oracleReports) {
                    reports.push(new entities_1.Report(r));
                }
                skip += queries_1.MAX_PER_PAGE;
            }
            catch (e) {
                break;
            }
        }
        return reports;
    });
}
exports.getOracleProviderReports = getOracleProviderReports;
function getRebases(policy, client) {
    return __awaiter(this, void 0, void 0, function* () {
        let skip = 0;
        const rebases = [];
        while (true) {
            try {
                const dt = yield client
                    .query(queries_1.GET_REBASES, {
                    id: policy.address.toLowerCase(),
                    first: queries_1.MAX_PER_PAGE,
                    skip: skip,
                })
                    .toPromise();
                if (!dt.data || dt.data.rebases.length == 0) {
                    break;
                }
                for (const r of dt.data.rebases) {
                    rebases.push(new entities_1.Rebase(r));
                }
                skip += queries_1.MAX_PER_PAGE;
            }
            catch (e) {
                break;
            }
        }
        return rebases;
    });
}
exports.getRebases = getRebases;
function getXCRebases(controller, client) {
    return __awaiter(this, void 0, void 0, function* () {
        let skip = 0;
        const rebases = [];
        while (true) {
            try {
                const dt = yield client
                    .query(queries_1.GET_XC_REBASES, {
                    id: controller.address,
                    first: queries_1.MAX_PER_PAGE,
                    skip: skip,
                })
                    .toPromise();
                if (!dt.data || dt.data.xcrebases.length == 0) {
                    break;
                }
                for (const r of dt.data.xcrebases) {
                    rebases.push(new entities_1.XCRebase(r));
                }
                skip += queries_1.MAX_PER_PAGE;
            }
            catch (e) {
                break;
            }
        }
        return rebases;
    });
}
exports.getXCRebases = getXCRebases;
function getBCTokenBalances(token, addresses, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const dt = yield client
            .query(queries_1.GET_TOKEN_BALANCES, {
            id: token.address.toLowerCase(),
            accounts: addresses.map((a) => a.toLowerCase()),
        })
            .toPromise();
        const balances = [];
        for (const b of dt.data.tokenBalances) {
            balances.push(new entities_1.TokenBalance(b));
        }
        return balances;
    });
}
function getBCTokenBalance(token, address, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const dt = yield client
            .query(queries_1.GET_TOKEN_BALANCES, {
            id: token.address.toLowerCase(),
            accounts: [address.toLowerCase()],
        })
            .toPromise();
        return new entities_1.TokenBalance(dt.data.tokenBalances[0]);
    });
}
function getBCTokenApproval(token, owner, spender, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const dt = yield client
            .query(queries_1.GET_TOKEN_APPROVAL, {
            id: token.address.toLowerCase(),
            owner: owner.toLowerCase(),
            spender: spender.toLowerCase(),
        })
            .toPromise();
        return new entities_1.TokenApproval(dt.data.tokenApprovals[0]);
    });
}
function getXCTokenBalances(xctoken, addresses, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const dt = yield client
            .query(queries_1.GET_XC_TOKEN_BALANCES, {
            id: xctoken.address.toLowerCase(),
            accounts: addresses.map((a) => a.toLowerCase()),
        })
            .toPromise();
        const balances = [];
        for (const b of dt.data.xctokenBalances) {
            balances.push(new entities_1.TokenBalance(b));
        }
        return balances;
    });
}
function getXCTokenBalance(xctoken, address, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const dt = yield client
            .query(queries_1.GET_XC_TOKEN_BALANCES, {
            id: xctoken.address.toLowerCase(),
            accounts: [address.toLowerCase()],
        })
            .toPromise();
        return new entities_1.TokenBalance(dt.data.xctokenBalances[0]);
    });
}
function getXCTokenApproval(xctoken, owner, spender, client) {
    return __awaiter(this, void 0, void 0, function* () {
        const dt = yield client
            .query(queries_1.GET_XC_TOKEN_APPROVAL, {
            id: xctoken.address.toLowerCase(),
            owner: owner.toLowerCase(),
            spender: spender.toLowerCase(),
        })
            .toPromise();
        return new entities_1.TokenApproval(dt.data.xctokenApprovals[0]);
    });
}
function getTokenBalances(token, addresses, client) {
    return __awaiter(this, void 0, void 0, function* () {
        if (token instanceof entities_1.XCToken) {
            return getXCTokenBalances(token, addresses, client);
        }
        return getBCTokenBalances(token, addresses, client);
    });
}
exports.getTokenBalances = getTokenBalances;
function getTokenBalance(token, address, client) {
    return __awaiter(this, void 0, void 0, function* () {
        if (token instanceof entities_1.XCToken) {
            return getXCTokenBalance(token, address, client);
        }
        return getBCTokenBalance(token, address, client);
    });
}
exports.getTokenBalance = getTokenBalance;
function getTokenApproval(token, owner, spender, client) {
    return __awaiter(this, void 0, void 0, function* () {
        if (token instanceof entities_1.XCToken) {
            return getXCTokenApproval(token, owner, spender, client);
        }
        return getBCTokenApproval(token, owner, spender, client);
    });
}
exports.getTokenApproval = getTokenApproval;
// Helper functions
function getAmpleforthMarketOracle(chainID = DEFAULT_CHAIN_ID, client = DEFAULT_CLIENT) {
    const addresses = deployments.getDeployment(chainID);
    return getOracle(addresses.MarketOracle.toLowerCase(), client);
}
exports.getAmpleforthMarketOracle = getAmpleforthMarketOracle;
function getAmpleforthCPIOracle(chainID = DEFAULT_CHAIN_ID, client = DEFAULT_CLIENT) {
    const addresses = deployments.getDeployment(chainID);
    return getOracle(addresses.CPIOracle.toLowerCase(), client);
}
exports.getAmpleforthCPIOracle = getAmpleforthCPIOracle;
function getAmpleforthCPIOracles(chainID = DEFAULT_CHAIN_ID, client = DEFAULT_CLIENT) {
    const addresses = deployments.getDeployment(chainID);
    return Promise.all([addresses.CPIOracle]
        .concat(addresses.PrevCPIOracles)
        .map((a) => getOracle(a.toLowerCase(), client)));
}
exports.getAmpleforthCPIOracles = getAmpleforthCPIOracles;
function getAmpleforthPolicy(chainID = DEFAULT_CHAIN_ID, client = DEFAULT_CLIENT) {
    const addresses = deployments.getDeployment(chainID);
    return getPolicy(addresses.Policy.toLowerCase(), client);
}
exports.getAmpleforthPolicy = getAmpleforthPolicy;
function getAMPLToken(chainID = DEFAULT_CHAIN_ID, client = DEFAULT_CLIENT) {
    const addresses = deployments.getDeployment(chainID);
    return getToken(addresses.Token.toLowerCase(), client);
}
exports.getAMPLToken = getAMPLToken;
function getXCAmpleController(chainID, client) {
    const addresses = deployments.getXCDeployment(chainID);
    return getXCController(addresses.XCController.toLowerCase(), client);
}
exports.getXCAmpleController = getXCAmpleController;
function getXCAmpleToken(chainID, client) {
    const addresses = deployments.getXCDeployment(chainID);
    return getXCToken(addresses.XCToken.toLowerCase(), client);
}
exports.getXCAmpleToken = getXCAmpleToken;
//# sourceMappingURL=index.js.map